<template>
  <div class="home">
    <header>
      <div class="header-title">{{$t('lang.message.homeTitle')}}</div>
      <div class="user-box">
        <el-dropdown class="user-box" trigger="click" placement="bottom">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid"></i>{{username}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>详情</el-dropdown-item> -->
            <el-dropdown-item @click.native="logout">{{$t('lang.message.logout')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <aside>
      <div class="bglogo"></div>
      <ul>
        <router-link
          :to="item.componentName"
          :class="{actived: index === activedIndex}"
          v-for="(item, index) in menuData"
          :key="index"
          @click.native="changeMenuState(index)"
          tag="li"
        >
          <i :class="item.iconMsg"></i>
          <span>{{item.name}}</span>
        </router-link>
      </ul>
    </aside>
    <div class="main">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      activedIndex: parseInt(sessionStorage.getItem("active_i")) || 0,
      menuData: [
        {
          id: 0,
          iconMsg: "el-icon-menu",
          name: this.$t('lang.message.menuUser'),
          componentName: "user"
        },
        {
          id: 1,
          iconMsg: "el-icon-location",
          name: this.$t('lang.message.menuDev'),
          componentName: "devices"
        }
      ]
    };
  },
  mounted() {
    this.username = sessionStorage.getItem("TC_username");
    this.activedIndex = parseInt(sessionStorage.getItem("active_i")) || 0;
    // this.$router.push("/user");
  },
  methods: {
    changeMenuState(i) {
      this.activedIndex = i;
      sessionStorage.setItem("active_i", this.activedIndex);
    },
    logout() {
      window.console.log(sessionStorage.token);
      this.$http.delete('TC/logout').then(res => {
        window.console.log(res);
        if(res.data.status === 200) {
          this.$message({
            showClose: true,
            message: this.$t("lang.message.exit"),
            type: "success",
            duration: 1000
          });
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('active_i');
          setTimeout(()=>this.$router.push("/login"),1000);
        }
      }).catch(err => {
        window.console.log(err);
      })
    }
  }
};
</script>

<style scoped>
.actived {
  background: #409eff;
  color: #fff;
}

.home {
  width: 100%;
  height: 100%;
  background: #f1f2f9;
  position: relative;
}

header {
  width: calc(100% - 200px);
  height: 60px;
  background: #fff;
  position: absolute;
  top: 0;
  right: 0;
}

aside {
  width: 200px;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
}

.bglogo {
  width: 100%;
  height: 60px;
  background: url("../assets/imgs/logo.png") no-repeat center center;
}

.header-title {
  display: inline-block;
  width: auto;
  height: 100%;
  line-height: 60px;
  padding-left: 20px;
  color: #666;
  font-size: 20px;
  font-weight: bold;
  float: left;
}

aside li {
  width: 100%;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  color: #666;
  font-size: 16px;
  text-align: left;
}

aside li:hover {
  background: #409eff;
}

aside li:hover * {
  color: #fff;
}

aside li i {
  margin: 0 10px 0 22px;
}

.user-box {
  height: 100%;
  line-height: 60px;
  font-size: 18px;
  margin-right: 20px;
  float: right;
  cursor: pointer;
}

.main {
  width: calc(100% - 230px);
  height: calc(100% - 90px);
  position: absolute;
  top: 75px;
  right: 15px;
  background: #fff;
}
</style>